export const getHomePath = () => '/home';

/** Location state set when the user clicks the Aula logo. */
export const AULA_LOGO_NAV_STATE = { viaAulaLogo: true as const };

/** Held in leaveDestinationPath only until leave-without-saving confirms. */
const AULA_LOGO_LEAVE_MARKER = 'viaAulaLogo=1';

export const getAulaLogoLeaveDestination = () =>
  `${getHomePath()}?${AULA_LOGO_LEAVE_MARKER}`;

export const isAulaLogoNavState = (state: unknown): boolean =>
  Boolean(
    state &&
      typeof state === 'object' &&
      (state as { viaAulaLogo?: boolean }).viaAulaLogo === true
  );

export const isAulaLogoLeaveDestination = (
  path: string | null | undefined
): boolean =>
  typeof path === 'string' &&
  (path === getAulaLogoLeaveDestination() ||
    path.startsWith(`${getHomePath()}?${AULA_LOGO_LEAVE_MARKER}`));

export const getAnnouncementsPath = (spaceId: string) =>
  `/dashboard/${spaceId}/community/announcements`;

export const getCommonRoomPath = (spaceId: string) =>
  `/dashboard/${spaceId}/community/common-room`;

export const getAssignmentsPath = (spaceId: string) =>
  `/dashboard/${spaceId}/journey/assignments`;
